import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStrideLength = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 25,
	height: 33.979,
	viewBox: "0 0 25 33.979",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_91",
		"data-name": "Group 91",
		transform: "translate(-134.833 -408.075)",
		children: [/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_25",
			"data-name": "Rectangle 25",
			width: 24,
			height: 24,
			transform: "translate(135.333 417.554)",
			fill: "none",
			stroke: "#040505",
			strokeMiterlimit: 10,
			strokeWidth: 1,
			opacity: 0
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_90",
			"data-name": "Group 90",
			transform: "translate(137.338 408.075)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_216",
					"data-name": "Path 216",
					d: "M162.546,430.4a2.277,2.277,0,0,0,.268.016h2.259a.75.75,0,1,0,0-1.5h-.39a8.649,8.649,0,0,0,.456-1.81c.033-.2.062-.373.095-.517.041-.184.141-.5.248-.83A10.262,10.262,0,0,0,166.1,423a4.606,4.606,0,0,0-1.263-3.348,2.563,2.563,0,0,0-1.977-.7c-1.562.114-2.38,1.8-2.38,3.408a6.058,6.058,0,0,0,.316,1.845,3.347,3.347,0,0,1,.194.962,8.883,8.883,0,0,1-.127,1.158c-.172,1.155-.367,2.465.3,3.334a1.949,1.949,0,0,0,1.384.739Zm.423-9.952a1.074,1.074,0,0,1,.847.307A3.2,3.2,0,0,1,164.6,423a9.6,9.6,0,0,1-.548,2.3c-.122.381-.227.71-.283.959-.038.166-.072.37-.11.6-.214,1.274-.462,2.115-.94,2.054-.269-.031-.341-.126-.369-.161-.28-.365-.121-1.427-.006-2.2a9.871,9.871,0,0,0,.143-1.379,4.657,4.657,0,0,0-.256-1.39,4.584,4.584,0,0,1-.253-1.417C161.98,421.474,162.359,420.491,162.969,420.447Z",
					transform: "translate(-153.061 -418.944)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_217",
					"data-name": "Path 217",
					d: "M186,455.047l-.717.717v-3.25l.717.716a.749.749,0,0,0,1.06-1.06l-2-2a.748.748,0,0,0-.115-.094c-.018-.012-.037-.02-.056-.03a.668.668,0,0,0-.073-.039.734.734,0,0,0-.075-.023.652.652,0,0,0-.065-.019.748.748,0,0,0-.294,0,.658.658,0,0,0-.065.019.737.737,0,0,0-.075.023.673.673,0,0,0-.073.039c-.019.01-.038.018-.056.03a.749.749,0,0,0-.115.094l-2,2a.749.749,0,1,0,1.06,1.06l.716-.716v3.249l-.716-.716a.749.749,0,0,0-1.06,1.06l2,2a.749.749,0,0,0,1.06,0l2-2a.749.749,0,0,0-1.06-1.06Z",
					transform: "translate(-166.386 -438.333)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_218",
					"data-name": "Path 218",
					d: "M184.043,447.046h2.249a.75.75,0,0,0,0-1.5h-2.249a.75.75,0,0,0,0,1.5Z",
					transform: "translate(-167.324 -435.577)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_219",
					"data-name": "Path 219",
					d: "M186.291,472.794h-2.249a.75.75,0,1,0,0,1.5h2.249a.75.75,0,1,0,0-1.5Z",
					transform: "translate(-167.324 -452.613)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_220",
					"data-name": "Path 220",
					d: "M168.138,472.794h-3.668a.75.75,0,1,0,0,1.5h3.668a.75.75,0,1,0,0-1.5Z",
					transform: "translate(-155.087 -452.613)",
					fill: "current"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_221",
					"data-name": "Path 221",
					d: "M146.4,456.162h-.421a6.712,6.712,0,0,0-.057-2.589,8.958,8.958,0,0,1-.127-1.158,3.344,3.344,0,0,1,.194-.962,6.059,6.059,0,0,0,.316-1.845c0-1.608-.818-3.295-2.38-3.408a2.572,2.572,0,0,0-1.977.705,4.606,4.606,0,0,0-1.263,3.348,10.252,10.252,0,0,0,.62,2.755c.106.331.207.644.248.828.032.143.061.32.094.515.184,1.093.557,3.312,2.325,3.312.039,0,.081-.005.122-.008.019,0,.038.006.058.006H146.4a.75.75,0,1,0,0-1.5Zm-3.386-2.654c-.055-.25-.161-.578-.283-.958a9.618,9.618,0,0,1-.548-2.3,3.2,3.2,0,0,1,.785-2.251,1.076,1.076,0,0,1,.757-.311q.044,0,.09,0c.611.044.989,1.027.989,1.913a4.588,4.588,0,0,1-.254,1.417,4.663,4.663,0,0,0-.256,1.39,9.831,9.831,0,0,0,.144,1.379c.115.775.273,1.837-.006,2.2-.027.035-.1.129-.368.161-.493.06-.726-.781-.941-2.055C143.085,453.877,143.05,453.673,143.013,453.507Z",
					transform: "translate(-140.683 -435.981)",
					fill: "current"
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgStrideLength);
export { ForwardRef as ReactComponent };
